// extracted by mini-css-extract-plugin
module.exports = {"container":"Offers_container__1ekc1","col":"Offers_col__3grT0","heading":"Offers_heading__2QsnJ","details":"Offers_details__25w6-"};